import { render, staticRenderFns } from "./ModifyCommodity.vue?vue&type=template&id=5d94716a"
import script from "./ModifyCommodity.vue?vue&type=script&lang=js"
export * from "./ModifyCommodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports